export const parserBlockName = 'cdm-customizations-qlmarketplace';
export const parserClassName = 'ql-marketplace-container';
export const attribNames = {
    PRODUCT: 'data-product',
    VARIANT: 'data-variant',
    SHOW_HEADER: 'data-showheader',
};
export const sourceAttributes = {
    SUFFIX: 'mkt',
}
